import {
    ExamplePagesOccupationBeats,
    EXAMPLE_PAGES_OCCUPATION_BEATS_NUMBER_OF_PAGES,
    SEO_RESULTS_PER_PAGE,
    SEO_URL_EXAMPLE_PAGES_SUFIX
} from "@authory-packages/seo-static-data";
import { ExamplesPageLayout } from "../../../pagelayouts/examples";
import { APPLICATION_ROUTES } from "../../../shared-logic/routes";

const ExampleJobPage = () => (
    <ExamplesPageLayout
        title={<>Discover Portfolio Examples by Professional Category</>}
        description={
            <>Explore Authory portfolio examples from different professional categories. Check how professionals showcase and manage their work.</>
        }
        panelLinks={ExamplePagesOccupationBeats.slice(0, 100).map((occ) => ({
            url: `${APPLICATION_ROUTES.EXAMPLES}/${occ.key}${SEO_URL_EXAMPLE_PAGES_SUFIX}`,
            label: occ.occupation
        }))}
        categoriesLinks={[]}
        masonryItems={{ users: [] }}
        ogTitle={"Portfolio Examples by Professional Category | Authory"}
        ogDescription={"Browse Authory portfolio examples by professional category, and learn how professionals manage their work samples."}
        embedConf={[]}
        pagination={{
            page: 1,
            limit: SEO_RESULTS_PER_PAGE,
            pages: EXAMPLE_PAGES_OCCUPATION_BEATS_NUMBER_OF_PAGES,
            total: ExamplePagesOccupationBeats.length,
            prev: null,
            next: 2 < EXAMPLE_PAGES_OCCUPATION_BEATS_NUMBER_OF_PAGES ? 2 : null
        }}
        paginationURL={APPLICATION_ROUTES.EXAMPLES_PROFESSION_CATEGORIES}
        faq={[]}
    />
);

export default ExampleJobPage;
